export default __webpack_public_path__ + "assets/insuranceCard-component.dabd7680.svg";